module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus-bottom.6339aae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus-bottom.svg
// module id = 1783
// module chunks = 1